import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TcpGraphComponent } from './tcp-graph.component';

const routes: Routes = [
  {
    path: '',
    component: TcpGraphComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TcpGraphRoutingModule {}
